<template>
  <div class="leads">
    <v-card
      flat
      class="pa-4 d-flex flex-row flex-wrap justify-center"
    >
      <v-radio-group
        v-model="scopeClients"
        row
        class="mt-0"
        @change="getClients(scopeClients)"
      >
        <v-radio
          label="Ongoing"
          value="ongoing"
          class="my-0 py-0"
        />
        <v-radio
          label="Completed"
          value="completed"
          class="my-0 py-0"
        />
      </v-radio-group>
    </v-card>
    <v-data-table
      :headers="headersClients"
      :items="clients"
      sort-by="start"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [itemsPerPage]
      }"
      :search="searchClients"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <div class="d-flex flex-row flex-wrap justify-center">
            <!-- <v-toolbar-title class="mr-4">Resources</v-toolbar-title> -->
            <v-card flat>
              <v-text-field
                v-model="searchClients"
                append-icon="$vuetify.icons.icon_mdi_magnify"
                :label="'Search ' + `${ clients.length }` + ' client(s)'"
                single-line
                hide-details
                style="width: 300px"
                clearable
              />
            </v-card>
          </div>
        </v-toolbar>
      </template>

      <template v-slot:[`item.full_name`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-row align-center">
              <v-btn 
                x-small
                fab
                v-bind="attrs"
                class="mr-3" 
                v-on="on"
                @click="goClient(item.id)"
              >
                <v-icon>mdi-arrow-up-bold</v-icon>
              </v-btn>
              <strong>{{ item.full_name }}</strong>
            </div>
          </template>
          <span>Go to Client</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.gender`]="{ item }">
        <v-icon
          v-if="`${item.gender}` === 'Male'"
          small
          color="ppc_darkgreen"
        >
          fa-male
        </v-icon>
        <v-icon
          v-else-if="`${item.gender}` === 'Female'"
          small
          color="ppc_darkgreen"
        >
          fa-female
        </v-icon>
        <v-icon
          v-else
          small
          color="ppc_darkgreen"
        >
          fa-genderless
        </v-icon>
      </template>

      <template v-slot:[`item.onlyEnglishCourses`]="{ item }">
        <div v-if="`${item.onlyEnglishCourses}` === '1'">
          <v-icon small>
            $vuetify.icons.icon_english
          </v-icon>
        </div>
      </template>

      <template v-slot:[`item.start_first`]="{ item }">
        {{ formattedDate(item.start_first, 'date') }}
      </template>

      <template v-slot:[`item.end_last`]="{ item }">
        {{ formattedDate(item.end_last, 'date') }}
      </template>

      <template v-slot:[`item.statusClientId`]="{ item }">
        <v-chip
          small
          :color="`${getStatus(item.statusClientId).color}`"
          text-color="white"
          v-html="`${getStatus(item.statusClientId).name}`"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import dayjs from 'dayjs';
export default {

  mixins: [inputRules, formattedDate],

  data() {
    return {
      arrivals: null,
      dialogAddLead: false,
      loading: false,
      itemsNationality: [],
      itemsSource: [],
      errorMessageNames: '',
      first_name: '',
      last_name: '',
      sourceId: 1,
      agencyId: null,
      clients: [],
      scopeClients: 'ongoing',
      headersClients: [
        { text: 'Full Name', align: 'start', value: 'full_name' },
        { text: 'Email', value: 'email' },
        { text: 'Gender', value: 'gender', width: "100px", sortable: false},
        { text: 'Nationality', value: 'nationality' },
        { text: 'Source/Agency', value: 'source' },
        { text: 'Only English', value: 'onlyEnglishCourses' },
        { text: 'Start', value: 'start_first', width: '120px' },
        { text: 'End', value: 'end_last', width: '120px' },
        { text: 'Status', value: 'statusClientId' },
      ],
      addLeadValid: true,
      arrayUpload: [],
      searchClients: '',
    }
  },
  computed: {
    successMessage () {
      return this.$store.getters.successMessage
    },
    itemsPerPage () {
        return this.$store.getters.itemsPerPage
    },
  },
  
  watch: {
    successMessage: function () {
      if (this.successMessage !== "") {
        this.alertSuccessMessage = true;
      }
    },
  },
  beforeCreate () {
    this.$store.dispatch('setLoadingApp', 1)
  },
  created () {
    dayjs.locale("en");
    this.initialize();
  },
  methods: {
    async initialize () {
      this.$store.dispatch('breadcrumbs', ['Clients']);
      await this.getClients('ongoing');
    },
    goClient(id) {
      this.$store.dispatch('setLoadingApp', 1);
      this.$router.push({ name: 'Client', params: { id: id } })
    },
    
    getStatus(id) {
      return this.$store.state.statusClients.filter((select_item) => {
        return select_item.id === id;
      })[0];
    },

    async getClients(scopeClients) {

      this.$store.dispatch('setLoadingApp', 1);
      if (scopeClients === 'ongoing') {
        this.clients = await this.$store.dispatch('getClients');
      } else {
        this.clients = await this.$store.dispatch('getClientsCompleted');
      }
      for (let index = 0; index < this.clients.length; index++) {

        const nationalityId = this.clients[index].nationality_id;
        let nationality = this.$store.state.itemsNationality.filter((select_item) => {
          return select_item.id === nationalityId;
        })
        if (nationality.length > 0) {
          this.clients[index].nationality = nationality[0].nationality;
        }

        const agencyId = this.clients[index].agency_id;
        let agency = this.$store.state.available_agencies.filter((select_item) => {
          return select_item.id === agencyId;
        })
        if (agency.length > 0) {
          this.clients[index].source = agency[0].name;
        } else {
          const sourceId = this.clients[index].source_id;
          let source = this.$store.state.itemsSources.filter((select_item) => {
            return select_item.id === sourceId;
          })
          if (source.length > 0) {
            this.clients[index].source = source[0].name;
          }
        }
        
      }
      this.$store.dispatch('setLoadingApp', 0);

    },

  },
}
</script>